import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumb.css';

export default function Breadcrumb({ items = [], className = '' }) {
    const location = useLocation();

    // Auto-generate breadcrumbs from path if items not provided
    const breadcrumbs = items.length > 0 ? items : generateBreadcrumbs(location.pathname);

    return (
        <nav className={`breadcrumb ${className}`} aria-label="Breadcrumb">
            <ol className="breadcrumb-list">
                <li className="breadcrumb-item">
                    <Link to="/" className="breadcrumb-link">
                        <Home size={16} />
                    </Link>
                </li>
                {breadcrumbs.map((item, index) => (
                    <li key={index} className="breadcrumb-item">
                        <ChevronRight size={14} className="breadcrumb-separator" />
                        {item.path && index < breadcrumbs.length - 1 ? (
                            <Link to={item.path} className="breadcrumb-link">
                                {item.label}
                            </Link>
                        ) : (
                            <span className="breadcrumb-current">{item.label}</span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}

function generateBreadcrumbs(pathname) {
    const pathMap = {
        'purchase-requests': 'Purchase Requests',
        'vendors': 'Vendors',
        'rfq': 'RFQ',
        'contracts': 'Contracts',
        'purchase-orders': 'Purchase Orders',
        'goods-receipts': 'Goods Receipt',
        'invoices': 'Invoices',
        'payments': 'Payments',
        'catalog': 'Catalog',
        'budgets': 'Budgets',
        'reports': 'Reports',
        'users': 'Users',
        'settings': 'Settings',
        'create': 'Create',
        'edit': 'Edit',
        'view': 'View'
    };

    const parts = pathname.split('/').filter(Boolean);
    let currentPath = '';

    return parts.map((part) => {
        currentPath += `/${part}`;
        return {
            path: currentPath,
            label: pathMap[part] || part.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
        };
    });
}

Breadcrumb.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string
    })),
    className: PropTypes.string
};
